module.exports = "<p>\n  management works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/management/management.component.html
// module id = ../../../../../src/app/components/management/management.component.html
// module chunks = main